<template>
    <div>
        <label v-if="title" class="block mb-1 text-sm font-medium text-gray-700">{{ title }}</label>
        <ul class="border border-gray-200 rounded-md divide-y divide-gray-200">
            <li v-for="(item, index) in items" :key="index" class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                <div class="w-0 flex-1 flex items-center">
                    <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clip-rule="evenodd"></path></svg>
                    <span class="ml-2 flex-1 w-0 truncate">
                        {{ baseName(item) }}
                    </span>
                </div>
                <div class="ml-4 flex-shrink-0">
                    <a :href="route('media.download', {filename: baseName(item)})" class="font-medium text-teal">
                        Download
                    </a>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    setup(){
        function baseName(filepath){
            return (_.isString(filepath)) ? filepath.substr(filepath.lastIndexOf('/') + 1) : filepath
        }

        return { baseName }
    }
}
</script>

<style>

</style>
